/**
 * Copy for the subscription checkout, which depends on who is charging.
 *
 * On MercadoPago the email is not just a contact address: the preapproval is
 * charged against *that* MercadoPago account, so the payer has to give the
 * right one or the charge fails. On a hosted checkout (Rebill) the email is
 * only a prefill and the payer can change it on the provider's own page, so
 * demanding a MercadoPago account there is both wrong and confusing.
 *
 * `paymentProviderCode` comes from `PriceType.paymentProviderCode`, which is
 * null when the price has no `ProviderPlan` — the generic copy covers that.
 */

const MERCADO_PAGO = "mercado_pago";

export type CheckoutCopy = {
  emailLabel: string;
  emailHelp: string;
  emailRequiredMessage: string;
  redirectNotice: string;
};

const MERCADO_PAGO_COPY: CheckoutCopy = {
  emailLabel: "Correo de tu cuenta de MercadoPago",
  emailHelp:
    "Ingresa el correo de la cuenta de MercadoPago con la que harás el " +
    "pago: el cobro se efectuará a esa cuenta. Prellenamos tu correo de " +
    "Montu; cámbialo si pagarás con otra cuenta.",
  emailRequiredMessage: "Ingresa el correo de tu cuenta de MercadoPago",
  redirectNotice:
    "Serás redirigido a MercadoPago para completar el pago de forma segura.",
};

const GENERIC_COPY: CheckoutCopy = {
  emailLabel: "Correo para el pago",
  emailHelp:
    "Usaremos este correo para el cobro y los comprobantes de tu " +
    "suscripción. Prellenamos tu correo de Montu; cámbialo si prefieres " +
    "recibirlos en otro.",
  emailRequiredMessage: "Ingresa un correo para el pago",
  redirectNotice:
    "Serás redirigido a nuestra pasarela de pago para completar la " +
    "suscripción de forma segura.",
};

export const checkoutCopyFor = (
  paymentProviderCode: string | null | undefined,
): CheckoutCopy =>
  paymentProviderCode === MERCADO_PAGO ? MERCADO_PAGO_COPY : GENERIC_COPY;
